var React = require('react');

function IconCheckLightBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.7545 0.428436C13.3238 0.99888 13.3228 1.92284 12.7524 2.49214L5.75283 9.47776C5.39399 9.83588 4.89526 9.96836 4.43293 9.87538C4.07959 9.85887 3.73098 9.71521 3.46236 9.44412L0.422706 6.37658C-0.144562 5.80411 -0.140343 4.88017 0.43213 4.3129C1.0046 3.74563 1.92854 3.74985 2.49581 4.32232L4.62944 6.47556L10.6907 0.426377C11.2612 -0.142927 12.1851 -0.142009 12.7545 0.428436Z","fill":"#7280A9"}));
}

IconCheckLightBlue.defaultProps = {"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none"};

module.exports = IconCheckLightBlue;

IconCheckLightBlue.default = IconCheckLightBlue;
